import service from '../../utility/service';
import { errorOccurred } from '../../errors/reducer';

const INITIAL_STATE = {
  fetching: false,
  groups: undefined
};

const types = {
  FETCHING_GROUPS: 'orb/admin/groups/FETCHING_GROUPS',
  RECEIVED_GROUPS: 'orb/admin/groups/RECEVIED_GROUPS',
  UPDATED_GROUP: 'orb/admin/groups/UPDATED_GROUP',
  ADDED_GROUP: 'orb/admin/groups/ADDED_GROUP'
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.FETCHING_GROUPS:
      return Object.assign({}, state, {
        fetching: true
      });
    case types.RECEIVED_GROUPS:
      return Object.assign({}, state, {
        fetching: false,
        groups: action.groups
      });
    case types.UPDATED_GROUP:
      return Object.assign({}, state, {
        groups: state.groups
          .filter(g => g.Id !== action.group.Id)
          .concat([action.group])
          .sort((a, b) => a.Name.localeCompare(b.Name))
      });
    case types.ADDED_GROUP:
      return Object.assign({}, state, {
        groups: state.groups.concat([action.group])
          .sort((a, b) => a.Name.localeCompare(b.Name))
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

function fetchingGroups() {
  return { type: types.FETCHING_GROUPS };
}

function receivedGroups(groups) {
  return {
    type: types.RECEIVED_GROUPS,
    groups
  };
}

function updatedGroup(group) {
  return {
    type: types.UPDATED_GROUP,
    group
  };
}

function addedGroup(group) {
  return {
    type: types.ADDED_GROUP,
    group
  };
}

function shouldFetchGroups(state) {
  return !state.fetching && !state.groups;
}

export function fetchGroupsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState().admin.groups;
    if (shouldFetchGroups(state)) {
      dispatch(fetchingGroups());

      return service.get('/Admin/Groups').then(response => getAllGroupUsers(response.data).then((groups) => {
        dispatch(receivedGroups(groups));
      })).catch((err) => {
        dispatch(errorOccurred(err, 'Getting groups'));
        dispatch(receivedGroups([]));
      });
    }
    // Nothing to wait for
    return Promise.resolve();
  };
}

function getAllGroupUsers(groups) {
  return Promise.all(groups.map(getGroupWithUsers));
}

function getGroupWithUsers(group) {
  return service.get(`/Admin/GroupUsers/${group.Id}`).then(response => Object.assign({}, group, {
    Users: response.data
  }));
}

export function updateGroup(group) {
  const justGroup = {
    Id: group.Id,
    Name: group.Name,
    Active: group.Active
  };
  return dispatch => service.put('/Admin/Groups', [justGroup]).then((response) => {
    const groupWithUsers = Object.assign({}, response.data[0], { Users: group.Users });
    dispatch(updatedGroup(groupWithUsers));
  }).catch((err) => {
    dispatch(errorOccurred(err, 'Updating group'));
  });
}

export function addGroup(groupName) {
  return (dispatch) => {
    const group = {
      Id: 0,
      Active: true,
      Name: groupName
    };
    return service.post('/Admin/Groups', group).then((response) => {
      dispatch(addedGroup(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Adding group'));
    });
  };
}

export function addUserToGroup(user, group) {
  return dispatch => service.put(`/Admin/GroupUsers/${group.Id}/${user.Id}`).then((response) => {
    const newGroup = Object.assign({}, group, {
      Users: response.data
    });
    dispatch(updatedGroup(newGroup));
  }).catch((err) => {
    dispatch(errorOccurred(err, 'Adding user to group'));
  });
}

export function removeUserFromGroup(user, group) {
  return dispatch => service.delete(`/Admin/GroupUsers/${group.Id}/${user.Id}`).then((response) => {
    const newGroup = Object.assign({}, group, {
      Users: response.data
    });
    dispatch(updatedGroup(newGroup));
  }).catch((err) => {
    dispatch(errorOccurred(err, 'Removing user from group'));
  });
}



// WEBPACK FOOTER //
// ./src/admin/groups/reducer.js